<template>
  <div class="upload-sheet">
    <el-row :gutter="30" type="flex" class="upload-row">
      <el-col :xs="24" :sm="24" :md="14" :lg="16" :xl="16" class="upload-col-main">
        <el-upload
          class="upload-box"
          drag
          v-loading="loading"
          :action="`${base_url}/api/import/upload`"
          :multiple="true"
          :limit="1000"
          ref="fileUpload"
          :file-list="fileList"
          :on-success="upload"
          :on-remove="remove"
          accept=".xml,.csv,.txt"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Arraste os arquivos ou <em>clique aqui para enviar</em>
            <div class="el-upload__tip" slot="tip">
              Você pode enviar vários arquivos de uma só vez
            </div>
          </div>
        </el-upload>

        <div class="upload-summary" v-if="!xmlData && fileData.length > 0">
          <div class="upload-stat">
            <span class="upload-stat-value">{{ cols }}</span>
            <span class="upload-stat-label">Colunas identificadas</span>
          </div>
          <div class="upload-stat">
            <span class="upload-stat-value">{{ rows }}</span>
            <span class="upload-stat-label">Linhas da planilha</span>
          </div>
        </div>

        <div class="upload-summary" v-if="xmlData && fileData.length > 0">
          <div class="upload-stat">
            <span class="upload-stat-value">{{ rows }}</span>
            <span class="upload-stat-label">Notas fiscais carregadas</span>
          </div>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="10" :lg="8" :xl="8">
        <div class="upload-help">
          <div class="upload-help-section" v-if="sample">
            <span class="upload-help-title">Planilha de exemplo</span>
            <p class="upload-help-text">
              Não sabe como montar o arquivo? Baixe o modelo com as colunas esperadas e preencha a partir dele.
            </p>
            <el-button size="small" icon="el-icon-download" @click="downloadSample()">
              Baixar planilha de exemplo
            </el-button>
          </div>

          <div class="upload-help-section">
            <span class="upload-help-title">Formatos aceitos</span>
            <el-tag size="small" type="info">.CSV</el-tag>
            <el-tag size="small" type="info">.TXT</el-tag>
            <el-tag size="small" type="info">.XML (NF-e)</el-tag>
          </div>

          <div class="upload-help-section">
            <span class="upload-help-title">Cabeçalho</span>
            <el-switch v-model="header" active-text="A primeira linha do arquivo é cabeçalho"></el-switch>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="upload-footer right m-3" v-if="xmlData || fileData.length > 0">
      <el-button type="primary" @click="next()">Prosseguir<i class="el-icon-right el-icon--right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { UploadService } from "@/services/customers/upload.services";
export default {
  name: "UploadSheet",
  props: ["fileData", "xmlData", "sample"],
  computed: {
    cols() {
      if (this.fileData && this.fileData.length > 0) {
        return Object.keys(this.fileData[0]).length;
      }
      return 0;
    },
    rows() {
      return this.fileData.length;
    },
  },
  mounted() {
    const vm = this;
    if (vm.fileData.length === 0) {
      vm.fileList = [];
    }
  },
  methods: {
    isNFe(xmlString) {
      if (!xmlString) return false;

      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(xmlString, "application/xml");

        // Verifica erros de parsing
        if (doc.getElementsByTagName("parsererror").length > 0) {
          return false;
        }

        // Formatos possíveis:
        // <nfeProc><NFe><infNFe ...>...</infNFe></NFe></nfeProc>
        // <NFe><infNFe></infNFe></NFe>
        const nfe = doc.getElementsByTagName("NFe")[0];
        if (!nfe) return false;

        const inf = nfe.getElementsByTagName("infNFe")[0];
        if (!inf) return false;

        // Identificador deve existir
        const id = inf.getAttribute("Id");
        if (!id) return false;

        // Emitente e destinatário
        const emit = inf.getElementsByTagName("emit")[0];
        const dest = inf.getElementsByTagName("dest")[0];
        if (!emit || !dest) return false;

        return true;
      } catch (err) {
        return false;
      }
    },
    next() {
      const vm = this;
      vm.$emit("next");
    },
    downloadSample() {
      const header = [
        "DESTINATARIO", "CPF_CNPJ", "IE_DESTINATARIO", "ENDERECO", "NUMERO", "COMPLEMENTO", "BAIRRO", "CIDADE",
        "CEP", "UF", "SERVICO", "PESO", "ALTURA", "LARGURA", "COMPRIMENTO",
        "DCE_PRODUTO", "DCE_QTD", "DCE_VALOR", "DCE_EMITE", "TELEFONE_DESTINO",
      ];
      const rows = [
        ["TESTE MODICO", "12345678909", "", "AV ANTONIO CARLOS COSTA", "123", "CASA 1", "Jaguaré",
          "SÃO PAULO", "06053-004", "SP", "3220", "100", "6", "16", "23",
          "CAMISA", "1", "100", "SIM", "11986031160"],
      ];

      const csv = [header, ...rows].map((row) => row.join(";")).join("\r\n");
      const bytes = new Uint8Array(csv.length);
      for (let i = 0; i < csv.length; i++) {
        const code = csv.charCodeAt(i);
        bytes[i] = code <= 255 ? code : 63;
      }
      const blob = new Blob([bytes], { type: "text/csv;charset=iso-8859-1;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "modelo-importacao-prepostagem.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async upload() {
      const vm = this;
      const files = vm.$refs.fileUpload.uploadFiles.map(f => f.raw);

      const fileData = new FormData();
      files.forEach(file => fileData.append("files", file));

      vm.loading = true;

      try {
        const response = await UploadService.upload(fileData, vm.header);

        const xmlFiles = files.filter(f => f.name.toLowerCase().endsWith(".xml"));

        let isNFe = false;

        if (xmlFiles.length > 0) {
          // Lê cada XML e testa se é NFe
          const checks = await Promise.all(
            xmlFiles.map(file => {
              return new Promise(resolve => {
                const reader = new FileReader();
                reader.onload = (ev) => {
                  const content = ev.target.result;
                  resolve(vm.isNFe(content));
                };
                reader.readAsText(file);
              });
            })
          );

          // Se qualquer XML for NFe → true
          isNFe = checks.includes(true);

          // Emite a informação para o pai
          vm.$emit("detectNFe", isNFe);
        }

        if (isNFe) {
          vm.$emit("xml", response, files);
        } else {
          vm.$emit("upload", response[0], files);
        }

        vm.$message.success("Arquivos enviados com sucesso!");
      } catch (e) {
        vm.$message.error("Erro ao enviar arquivos: " + e);
      } finally {
        vm.loading = false;
      }
    },
    remove(file, fileList) {
      const vm = this;
      vm.fileList = fileList || [];
      if (vm.fileList.length === 0) {
        vm.$emit("upload", []);
      } else {
        vm.$emit("upload", vm.fileList.map(f => f.raw));
      }
      vm.$message.info(`Arquivo removido: ${file.name}`);
    },
  },
  data() {
    return {
      base_url: process.env.NODE_ENV === "development" ? "http://localhost:3000" : "",
      loading: false,
      header: true,
      fileList: [],
    };
  },
};
</script>
<style>
/* as duas colunas se esticam na mesma altura; a dropzone preenche a coluna */
.upload-sheet .upload-row {
  flex-wrap: wrap;
}

.upload-sheet .upload-col-main {
  display: flex;
  flex-direction: column;
}

.upload-sheet .upload-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.upload-sheet .upload-box > .el-upload {
  flex: 1;
  width: 100%;
}

.upload-sheet .el-upload-dragger {
  width: 100%;
  height: 100%;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-sheet .el-upload-dragger .el-icon-upload {
  margin: 0 0 12px;
}

/* arquivos selecionados em formato de card */
.upload-sheet .el-upload-list {
  margin-top: 10px;
}

.upload-sheet .el-upload-list__item {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  padding: 12px 14px;
  margin-top: 8px;
  font-size: 14px;
}

.upload-sheet .el-upload-list__item-name {
  margin-right: 60px;
  color: #303133;
  font-weight: 500;
}

.upload-sheet .el-upload-list__item-name [class^="el-icon"] {
  font-size: 16px;
  color: #409eff;
}

.upload-sheet .el-upload-list__item .el-icon-close {
  top: 16px;
  right: 14px;
}

.upload-sheet .el-upload-list__item-status-label {
  top: 12px;
  right: 14px;
}

.upload-summary {
  display: flex;
  margin-top: 20px;
}

.upload-stat {
  margin-right: 40px;
}

.upload-stat-value {
  display: block;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.upload-stat-label {
  font-size: 12px;
  color: #909399;
  text-transform: uppercase;
}

.upload-help {
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  padding: 5px 20px;
}

.upload-help-section {
  padding: 15px 0;
}

.upload-help-section + .upload-help-section {
  border-top: 1px solid #ebeef5;
}

.upload-help-title {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  text-transform: uppercase;
}

.upload-help-text {
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.4;
  color: #606266;
}

.upload-help .el-tag {
  margin-right: 5px;
}

.upload-footer {
  margin-top: 30px;
  text-align: center;
}

@media (max-width: 991px) {
  .upload-help {
    margin-top: 20px;
  }
}
</style>